import { Shield, Lock } from 'lucide-react'
import SeedPhraseLogin from '../components/auth/SeedPhraseLogin'

export default function Login() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-xl">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8">
          <div className="inline-flex items-center justify-center w-16 sm:w-20 h-16 sm:h-20 bg-doge-500/10 rounded-2xl mb-4">
            <img src="/dogici-logo.svg" alt="Dogici" className="w-10 sm:w-14 h-10 sm:h-14" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">Dogici Admin</h1>
          <p className="text-sm sm:text-base text-slate-400">
            Connect your authorized wallet to access the admin panel
          </p>
        </div>

        {/* Login Card */}
        <div className="card">
          <div className="flex items-center gap-2 mb-6 pb-4 border-b border-slate-700">
            <Lock size={20} className="text-doge-400" />
            <h2 className="font-semibold text-lg">Wallet Authentication</h2>
          </div>

          <SeedPhraseLogin />
        </div>

        {/* Security Notice */}
        <div className="mt-6 p-4 bg-slate-900/50 rounded-lg border border-slate-800">
          <div className="flex items-start gap-3">
            <Shield size={20} className="text-doge-400 mt-0.5" />
            <div>
              <h3 className="font-medium text-white mb-1">Security Notice</h3>
              <ul className="text-sm text-slate-400 space-y-1">
                <li>• Your wallet key is stored locally until you log out</li>
                <li>• It is never sent to any external server</li>
                <li>• Always verify you're on a secure, trusted device</li>
                <li>• Only authorized admin wallets can access the panel</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
